import { c as _c } from "react/compiler-runtime";
const Tick = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M11.1668 2L4.50016 10L1.8335 7.33333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Tick;